import { getDictGroups } from '@/api/login.js'

const dict_params = {
    dictGroup: "TOTYPE_,PRODUCT_,COTYPE_,ACCOUNT_,operator_group,sellType,MEALTYPE_,algorithm_group,packageType,defaultStrategy,MergeCode,secondCaterogy_lt,secondCaterogy_yd,interfaceName,agent_business_type,audience_object,interfaceList,platform_protocol,coupon_type,WEB_FRONT_CONFIG,system_env,WRITECARD_GROUP,AIOT_",
    type: "1"
}
const dictGroup = {
    state: {
        TOTYPE_: [],   //业务类型
        PRODUCT_: [],  //产品类型
        COTYPE_: [],   //合作类型
        ACCOUNT_: [],  //运营商
        operator_group: [], //web定义的 运营商
        sellType: [], //web定义的 套餐类型
        MEALTYPE_: [],  //套餐类型
        algorithm_group: [], //web定义的限速算法

        packageType: [],
        defaultStrategyList: [],
        mergeCode: [],
        secondCategory_yd: [],
        secondCategory_lt: [],
        interfaceName: [],
        agent_business_type: [],
        audience_object: [],
        interfaceList: [],
        platform_protocol: [],
        coupon_type: [],
        AIOT_: [], //AIOT产品列表
        isHuoma: "",
        isAutoRecharge: "",
        isGuangyao: "",
        showNewUi: "",
        showBatchUpdateCard: "",//是否显示批量修改卡信息
        domain_device_ip: "",//流量系统域名和设备管理IP
        TEMP_CARD: "",//写卡组中的临时卡
        REAL_NAME_LIMIT: "",//写卡组中的实名认证限制
        SHOW_ACCELERATION_PACK: "",//加速包是否显示；
        SHOW_MEAL_SERIES: "",//套餐系列是否显示
        SHOW_MERCHNUM: "",//是否显示商户号
        SHOW_PREARCHIVE: "",//是否显示预存
        SHOW_WALLETDISPLAYDAYS: "",//套餐延迟显示余额天数 FRONT_CONFIG_SHOW_WALLETDISPLAYDAYS
        SHOW_DISPLAYPRICE: "",//套餐约X/月     FRONT_CONFIG_SHOW_DISPLAYPRICE  
        IS_COMBINATION_MEAL: "",// 套餐是否折叠支付   FRONT_CONFIG_IS_COMBINATION_MEAL   
        IS_COMBINATION_PAY: "", //    套餐是否错位支付   FRONT_CONFIG_IS_COMBINATION_PAY   
        SHOW_MEALURL: "",//    套餐图片地址  FRONT_CONFIG_SHOW_MEALURL
        FRONT_CONFIG_MEAL_ACCELERATION_PACKAGE: "0",// 套餐加速包设置是否显示  FRONT_CONFIG_MEAL_ACCELERATION_PACKAGE

    },
    getters: {
        AIOT_: state => state.AIOT_,
        TOTYPE_: state => state.TOTYPE_,
        PRODUCT_: state => state.PRODUCT_,
        COTYPE_: state => state.COTYPE_,
        ACCOUNT_: state => state.ACCOUNT_,
        operator_group: state => state.operator_group,
        sellType: state => state.sellType,
        MEALTYPE_: state => state.MEALTYPE_,
        algorithm_group: state => state.algorithm_group,

        packageType: state => state.packageType,//套餐类型
        defaultStrategyList: state => state.defaultStrategyList,//虚值策略
        mergeCode: state => state.mergeCode,//合并码
        secondCategory_yd: state => state.secondCategory_yd, //二级运营商类别移动
        secondCategory_lt: state => state.secondCategory_lt, //二级运营商类别联通
        interfaceName: state => state.interfaceName,
        agent_business_type: state => state.agent_business_type,
        audience_object: state => state.audience_object,
        interfaceList: state => state.interfaceList,
        platform_protocol: state => state.platform_protocol,
        coupon_type: state => state.coupon_type,
        isHuoma: state => state.isHuoma,
        isAutoRecharge: state => state.isAutoRecharge,
        isGuangyao: state => state.isGuangyao,
        isBaoLiang: state => state.isBaoLiang,//是否是爆量独立部署
        showNewUi: state => state.showNewUi, // 是否时新UI, 1是新UI
        showBatchUpdateCard: state => state.showBatchUpdateCard,//是否显示批量修改卡信息  1 显示 0 不显示.
        domain_device_ip: state => state.domain_device_ip,
        TEMP_CARD: state => state.TEMP_CARD,//写卡组中的临时卡
        REAL_NAME_LIMIT: state => state.REAL_NAME_LIMIT,//写卡组中的实名认证限制
        SHOW_ACCELERATION_PACK: state => state.SHOW_ACCELERATION_PACK,
        SHOW_MEAL_SERIES: state => state.SHOW_MEAL_SERIES,
        SHOW_AD_CONFIG: state => state.SHOW_AD_CONFIG,
        SHOW_MERCHNUM: state => state.SHOW_MERCHNUM,
        SHOW_PREARCHIVE: state => state.SHOW_PREARCHIVE,
        SHOW_WALLETDISPLAYDAYS: state => state.SHOW_WALLETDISPLAYDAYS,
        SHOW_DISPLAYPRICE: state => state.SHOW_DISPLAYPRICE,
        IS_COMBINATION_MEAL: state => state.IS_COMBINATION_MEAL,
        IS_COMBINATION_PAY: state => state.IS_COMBINATION_PAY,
        SHOW_MEALURL: state => state.SHOW_MEALURL,
        FRONT_CONFIG_MEAL_ACCELERATION_PACKAGE: state => state.FRONT_CONFIG_MEAL_ACCELERATION_PACKAGE,
    },
    mutations: {
        SET_DICGROUP: (state, data) => {
            state.TOTYPE_ = data.TOTYPE_
            state.PRODUCT_ = data.PRODUCT_
            state.COTYPE_ = data.COTYPE_
            state.ACCOUNT_ = data.ACCOUNT_
            state.operator_group = data.operator_group
            state.sellType = data.sellType
            state.MEALTYPE_ = data.MEALTYPE_
            state.algorithm_group = data.algorithm_group
            state.AIOT_ = data.AIOT_ || []


            state.packageType = data.packageType
            state.defaultStrategyList = data.defaultStrategy
            state.mergeCode = data.MergeCode
            state.secondCategory_yd = data.secondCaterogy_yd
            state.secondCategory_lt = data.secondCaterogy_lt
            state.interfaceName = data.interfaceName
            state.agent_business_type = data.agent_business_type
            state.audience_object = data.audience_object
            state.interfaceList = data.interfaceList
            state.platform_protocol = data.platform_protocol
            state.coupon_type = data.coupon_type
            console.log(data)
            // state.domain_device_ip =   data.system_env  //  data.system_env 数组  
            data.system_env.forEach(e => {
                if (e.dictKey == "domain_device_ip") {
                    console.log(e.dictValue)
                    state.domain_device_ip = JSON.parse(e.dictValue)
                    console.log(state.domain_device_ip)
                }
            })
            data.WEB_FRONT_CONFIG.forEach(element => {
                if (element.dictKey == "FRONT_CONFIG_SHOW_LIVE_CODE") {
                    state.isHuoma = element.dictValue
                }
                if (element.dictKey == "FRONT_CONFIG_AUTO_RECHARGE_SWITCH") {
                    state.isAutoRecharge = element.dictValue
                }
                if (element.dictKey == "FRONT_CONFIG_SHOW_GUANGYAO") {
                    state.isGuangyao = element.dictValue
                }
                if (element.dictKey == "FRONT_CONFIG_ALL_IN_PAY") {
                    state.isBaoLiang = parseInt(element.dictValue)
                }
                if (element.dictKey == "FRONT_CONFIG_SHOW_NEW_UI") {
                    state.showNewUi = parseInt(element.dictValue)
                }
                if (element.dictKey == "FRONT_CONFIG_SHOW_BATCH_UPDATE_CARDINFO") {
                    state.showBatchUpdateCard = parseInt(element.dictValue)
                }
                if (element.dictKey == "FRONT_CONFIG_SHOW_ACCELERATION_PACK") {
                    state.SHOW_ACCELERATION_PACK = parseInt(element.dictValue)
                }
                if (element.dictKey == "FRONT_CONFIG_SHOW_MEAL_SERIES") {
                    state.SHOW_MEAL_SERIES = parseInt(element.dictValue)
                }
                if (element.dictKey == "FRONT_CONFIG_SHOW_AD_CONFIG") {
                    state.SHOW_AD_CONFIG = parseInt(element.dictValue)
                }

                if (element.dictKey == "FRONT_CONFIG_SHOW_MERCHNUM") {
                    state.SHOW_MERCHNUM = parseInt(element.dictValue)
                }

                if (element.dictKey == "FRONT_CONFIG_SHOW_PREARCHIVE") {
                    state.SHOW_PREARCHIVE = parseInt(element.dictValue)
                }
                if (element.dictKey == "FRONT_CONFIG_SHOW_WALLETDISPLAYDAYS") {
                    state.SHOW_WALLETDISPLAYDAYS = parseInt(element.dictValue)
                }
                if (element.dictKey == "FRONT_CONFIG_SHOW_DISPLAYPRICE") {
                    state.SHOW_DISPLAYPRICE = parseInt(element.dictValue)
                }
                if (element.dictKey == "FRONT_CONFIG_IS_COMBINATION_MEAL") {
                    state.IS_COMBINATION_MEAL = parseInt(element.dictValue)
                }
                if (element.dictKey == "FRONT_CONFIG_IS_COMBINATION_PAY") {
                    state.IS_COMBINATION_PAY = parseInt(element.dictValue)
                }
                if (element.dictKey == "FRONT_CONFIG_SHOW_MEALURL") {
                    state.SHOW_MEALURL = parseInt(element.dictValue)
                }
                if (element.dictKey == "FRONT_CONFIG_MEAL_ACCELERATION_PACKAGE") {
                    state.FRONT_CONFIG_MEAL_ACCELERATION_PACKAGE = parseInt(element.dictValue)
                }




            });



            data.WRITECARD_GROUP.forEach(e => {
                if (e.dictKey == "SHOW_BATCH_IMPORT_TEMP_CARD") {
                    console.log(e.dictValue)
                    state.TEMP_CARD = JSON.parse(e.dictValue)
                    console.log(state.TEMP_CARD)
                }
                if (e.dictKey == "SHOW_BATCH_IMPORT_WRITE_REAL_NAME_LIMIT") {
                    console.log(e.dictValue)
                    state.REAL_NAME_LIMIT = JSON.parse(e.dictValue)
                    console.log(state.REAL_NAME_LIMIT)
                }
            })

        }
    },
    actions: {
        getDictGroups({ commit }, res) {
            return new Promise((resolve) => {
                getDictGroups(dict_params).then((data) => {
                    commit('SET_DICGROUP', data)
                    resolve()
                })

            })
        },

    }
}

export default dictGroup